var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    staticClass: "lucky-card-dialog",
    attrs: {
      "flat": "",
      "max-width": "460"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.internalDialog,
      callback: function callback($$v) {
        _vm.internalDialog = $$v;
      },
      expression: "internalDialog"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "transparent",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1), _c('v-img', {
    staticClass: "lucky-card-dialog__image",
    attrs: {
      "src": "/images/event/clover/lucky-card-dialog--duplicate.jpg",
      "alt": "클로버6 카드를 뽑았다!"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 460 / 610
    }
  }, [_c('div', [_c('div', {
    staticClass: "dialog-spacer"
  }), _c('router-link', {
    staticClass: "dialog-button",
    attrs: {
      "to": "/mypage/event",
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/event/clover/dialog-button.svg",
      "alt": "이벤트 참여내역"
    }
  })], 1), _c('v-container', [_c('p', {
    staticClass: "page-text page-text--small text-center mt-14px"
  }, [_vm._v(" 나누리 캐시는 자동지급되며 "), _c('br'), _vm._v(" 마이페이지 - 내 캐시내역에서 받기 후 사용하실 수 있습니다. ")])])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }